/**
 * Test IDs for QA automation.
 */
export const testIds = {
  goodFormCommodityNamePicker: "good-form-commodity-name-picker",
  goodFormCommodityNameSearch: "good-form-commodity-name-search",
  goodFormQuantity: "good-form-quantity",
  goodFormCalculatedTonnage: "good-form-calculated-tonnage",
  goodFormPieces: "good-form-pieces",
  goodFormPallet: "good-form-pallet",
  goodFormPinCode: "good-form-pin-code",
  goodFormDelete: "good-form-delete",
} as const;
